import Listing from './components/layout'
import UserDetails from './components/UserDetailsDialog'


export default {
    Listing,
    UserDetails
}